import {useContext} from "react";
import {useRouter} from "next/router";
import AppContext from "/context/AppContext";
import FoyerInfoBackground from "/components/shared/layouts/FoyerInfoBackground";
import EnjoyTheShow from "/components/shared/EnjoyTheShow";
import RoomLayout from "/components/shared/layouts/RoomLayout";
import {motion} from "framer-motion";
import RoomButton from "/components/shared/buttons/RoomButton";
import PosterWall from "/components/shared/PosterWall";
import UpcomingShows from "/components/shared/UpcomingShows";
import {SvgTheaterCurtains1} from "/components/shared/SvgIcons";

export function Welcome() {
    return (
        <FoyerInfoBackground style="md:w-[25vw] p-4 mt-2 py-12 px-10">
          <h3 className="transition-transform text-white font-bold text-xl text-center w-full">
            Willkommen im
            <br/>
            Jungen Theater <br/> Bonn online!
          </h3>
          <div className="text-center text-white pt-2">
            <b className="text-red-600">BETA VERSION</b>
            <p >Bitte wenden Sie sich bei Fragen oder Problemen an <a href="mailto:info@jt-bonn.de">info@jt-bonn.de</a></p>
          </div>
        </FoyerInfoBackground>
    );
}

export default function FoyerDesktop() {
    const router = useRouter();
    const {activeShow, setActiveShow} = useContext(AppContext);

    return (
        <RoomLayout swiper={false} key="room" background="bg-cover bg-roomImage">
          <motion.div
            initial={{opacity: 0, scale: 0.5}}
            animate={{opacity: 1, scale: 1}}
            exit={{opacity: 0, scale: 0.5}}
          >
            <div
              className={`flex w-screen justify-center items-center flex-col xl:flex-row`}
            >
              <div>
                <UpcomingShows/>
              </div>
              <div className="flex flex-col mx-8 mt-[10vh]">
                <div>
                  {activeShow ? <EnjoyTheShow show={activeShow}/> : <Welcome/>}
                </div>
                <div className="w-full my-12">
                  <RoomButton href="/about-theater#theater" className="py-2">
                    <div className="mr-2">{SvgTheaterCurtains1("#AC8243")}</div>
                    Das Theater kennenlernen
                  </RoomButton>
                  <div className="flex justify-center pt-12">
                    <img
                      className="w-72"
                      src="/assets/images/neustart-kultur-logo.jpg"
                    />
                  </div>
                </div>
              </div>
              <div>
                <PosterWall/>
              </div>

            </div>
          </motion.div>
        </RoomLayout>
    );
}
